import { render, staticRenderFns } from "./carStopXiaBrand.vue?vue&type=template&id=2eeef22d&scoped=true"
import script from "./carStopXiaBrand.vue?vue&type=script&lang=js"
export * from "./carStopXiaBrand.vue?vue&type=script&lang=js"
import style0 from "./carStopXiaBrand.vue?vue&type=style&index=0&id=2eeef22d&prod&lang=stylus&scoped=true"
import style1 from "./carStopXiaBrand.vue?vue&type=style&index=1&id=2eeef22d&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eeef22d",
  null
  
)

export default component.exports